module.exports = __webpack_public_path__ + "static/media/spain.85f319c3.svg";